// Module
var code = `<page-header model="ctrl.navModel"></page-header>

<div class="page-container page-body">
	<table class="filter-table form-inline">
		<thead>
			<tr>
				<th>Name</th>
				<th>Value</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>Total dashboards</td>
				<td>{{ctrl.stats.dashboards}}</td>
			</tr>
			<tr>
				<td>Total users</td>
				<td>{{ctrl.stats.users}}</td>
			</tr>
			<tr>
				<td>Active users (seen last 14 days)</td>
				<td>{{ctrl.stats.activeUsers}}</td>
			</tr>
			<tr>
				<td>Total organizations</td>
				<td>{{ctrl.stats.orgs}}</td>
			</tr>
			<tr>
				<td>Total datasources</td>
				<td>{{ctrl.stats.datasources}}</td>
			</tr>
			<tr>
				<td>Total playlists</td>
				<td>{{ctrl.stats.playlists}}</td>
			</tr>
			<tr>
				<td>Total snapshots</td>
				<td>{{ctrl.stats.snapshots}}</td>
			</tr>
			<tr>
				<td>Total dashboard tags</td>
				<td>{{ctrl.stats.tags}}</td>
			</tr>
			<tr>
				<td>Total starred dashboards</td>
				<td>{{ctrl.stats.stars}}</td>
			</tr>
      <tr>
				<td>Total alerts</td>
				<td>{{ctrl.stats.alerts}}</td>
			</tr>
		</tbody>
	</table>
</div>
`;
// Exports
var _module_exports =code;;
var path = 'public/app/features/admin/partials/stats.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;